// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentful-entity-collection-field.disabled {
  filter: grayscale(80%); }

.contentful-entity-collection-field > .contentful-entity-collection-empty {
  margin-top: 0px;
  margin-bottom: 10px; }

.contentful-entity-collection-field > .contentful-entity-collection-wrapper {
  overflow-x: auto;
  margin-bottom: 10px; }
  .contentful-entity-collection-field > .contentful-entity-collection-wrapper > ul {
    display: table;
    margin: 0 -10px 0 -7px;
    border-spacing: 10px 0px;
    border-collapse: separate; }
    .contentful-entity-collection-field > .contentful-entity-collection-wrapper > ul > .contentful-entity-list-item {
      cursor: move;
      /* min-width: 300px; */
      min-width: 200px;
      display: table-cell; }
      .contentful-entity-collection-field > .contentful-entity-collection-wrapper > ul > .contentful-entity-list-item a {
        cursor: pointer; }

.contentful-entity-collection-field > .contentful-entity-selector {
  border-bottom: 1px solid #EEE;
  margin-bottom: 60px; }

.contentful-entity-list-item-sortable-helper {
  display: block; }
  .contentful-entity-list-item-sortable-helper .contentful-entity {
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.75); }
`, "",{"version":3,"sources":["webpack://./src/components/contentful/EntityCollectionField.scss"],"names":[],"mappings":"AAAA;EAEI,sBAAsB,EAAA;;AAF1B;EAMI,eAAe;EACf,mBAAmB,EAAA;;AAPvB;EAWI,gBAAgB;EAChB,mBAAmB,EAAA;EAZvB;IAeM,cAAc;IACd,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB,EAAA;IAlB/B;MAqBQ,YAAY;MACZ,sBAAA;MACA,gBAAgB;MAChB,mBAAmB,EAAA;MAxB3B;QA2BU,eAAe,EAAA;;AA3BzB;EAkCI,6BAA6B;EAC7B,mBAAmB,EAAA;;AAIvB;EACE,cAAc,EAAA;EADhB;IAII,2CAA2C,EAAA","sourcesContent":[".contentful-entity-collection-field {\n  &.disabled {\n    filter: grayscale(80%);\n  }\n\n  > .contentful-entity-collection-empty {\n    margin-top: 0px;\n    margin-bottom: 10px;\n  }\n\n  > .contentful-entity-collection-wrapper {\n    overflow-x: auto;\n    margin-bottom: 10px;\n\n    > ul {\n      display: table;\n      margin: 0 -10px 0 -7px;\n      border-spacing: 10px 0px;\n      border-collapse: separate;\n\n      > .contentful-entity-list-item {\n        cursor: move;\n        /* min-width: 300px; */\n        min-width: 200px;\n        display: table-cell;\n\n        a {\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  > .contentful-entity-selector {\n    border-bottom: 1px solid #EEE;\n    margin-bottom: 60px;\n  }\n}\n\n.contentful-entity-list-item-sortable-helper {\n  display: block;\n\n  .contentful-entity {\n    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.75);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
